import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { logger } from 'shared/lib'
import { initCanny } from 'entities/Canny'
import { eventHeartbeat } from 'entities/DataLog/events/EventHeartbeatLog'
import { initIntercom } from 'entities/Intercom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Sidebar } from 'widgets/Sidebar'
import { getAppData } from '../lib/loader'

const AuthLayout = observer(() => {
  const entities = useEntitiesContext()
  const { authStore, numbersStore, remindersStore } = entities

  useEffect(() => {
    if (!authStore.isRefresh) return
    if (authStore.isLoggedIn) {
      getAppData(entities)
        .catch(logger.error)
        .finally(() => {
          initCanny(entities)
          initIntercom({
            fromAuthorizedApp: true,
            entities: entities,
          })
          numbersStore.initStartNumberModal()
          numbersStore.initConnectTwilioModal()
          remindersStore.init()
          eventHeartbeat(entities)
        })
    }
  }, [authStore.isLoggedIn, authStore.isRefresh])

  return <Sidebar />
})

export default AuthLayout
